module.exports = __webpack_public_path__ + "static/media/017.5fdd6646.jpg";